<script setup lang="ts">
  const props = defineProps<{
    class?: string;
  }>();
</script>

<template>
  <div
    class="w-full h-px bg-gray-02"
    :class="props.class"
  />
</template>
